"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushChannel = void 0;
const action_1 = require("../../action");
const topic_1 = require("../../topic");
const PUSH_CHANNEL = 'push';
class PushChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = PUSH_CHANNEL;
        this.topics = {
            RegisterPushUpdates: new topic_1.Topic('RegisterPushUpdates', PUSH_CHANNEL, this._logger),
            initSuccess: new topic_1.Topic('initSuccess', PUSH_CHANNEL, this._logger),
            setNamedUserId: new action_1.Action('setNamedUserId', PUSH_CHANNEL, this._logger),
            setAlias: new action_1.Action('setAlias', PUSH_CHANNEL, this._logger),
            setTag: new action_1.Action('setTag', PUSH_CHANNEL, this._logger),
            setTagGroup: new action_1.Action('setTagGroup', PUSH_CHANNEL, this._logger),
            removeTag: new action_1.Action('removeTag', PUSH_CHANNEL, this._logger),
        };
    }
}
exports.PushChannel = PushChannel;
//# sourceMappingURL=push.channel.js.map